<div class="banner">
  <div class="col-12 pb-5">
    <h1>My Partners</h1>
  </div>
  <div class="tab">
    <ul class="nav nav-tabs">
      <li><a [routerLink]="[{ outlets: { 'partner-library-tab': ['my-brands'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Brand Client List</a>
        <span *ngIf="brandCount && brandCount !== 0" id="brandClientListBadge" class="badge rounded-pill">
          {{brandCount <= 99 ? brandCount : '&nbsp;!&nbsp;' }} </span>
      </li>
      <li><a [routerLink]="[{ outlets: { 'partner-library-tab': ['my-content-providers'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Content Provider List</a>
        <span *ngIf="contentProviderCount && contentProviderCount !== 0" id="conentProviderListBadge" class="badge rounded-pill">
          {{contentProviderCount <= 99 ? contentProviderCount : '&nbsp;!&nbsp;' }} </span>
      </li>
    </ul>
  </div>
</div>
<div class="tabcontent">
  <router-outlet name="partner-library-tab"></router-outlet>
</div>